import * as Yup from 'yup'

const Validation = Yup.object().shape({
  skillLevelId: Yup.string().required('Skill level is required'),
  skill: Yup.object().nullable().required('Skill is required'),
})

export default Validation
